class ProductFreeGift extends window.BAO.CustomElement() {
  connectedCallback () {
    this.listeners.add(this.els.trigger.element, 'click', this.handleTrigger)
  }

  setupListeners () {
    super.setupListeners()

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )

    document.addEventListener('KITE_AFTER_FREE_GIFT_ADD', this.onCartChanged)
  }

  async onCartChanged () {
    window.BAO.sectionRenderer
      .fetch(
        this.dataset.sectionId,
        `${window.location.pathname}?view=${this.localName}`,
      )
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res[this.dataset.sectionId],
        )

        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML

        window.BAO.eventBus.removeEventListener(
          window.BAO.EVENTS.PUSH_CART.CHANGED,
          this.onCartChanged,
        )

        document.removeEventListener(
          'KITE_AFTER_FREE_GIFT_ADD',
          this.onCartChanged,
        )
      })
      .catch(() => {})
  }

  handleTrigger () {
    const modal = document.querySelector(
      '[data-site-modal-key="free-gift"][data-site-modal-el="modal"]',
    )

    if (!modal) return

    modal.setAttribute('aria-hidden', 'false')
    document.body.classList.toggle('util-SiteOverflowed', true)
  }
}

if (!customElements.get('product-free-gift')) {
  customElements.define('product-free-gift', ProductFreeGift)
}
